export default __webpack_public_path__ + "37e34d29f39b95b7a4ac603b694733f2.svg";